import './GenericModal.css';
import { GenericModal, Modal } from './ModalAdapter';
import {
    html, text, header, ordered, unordered, bold, italic, code, link, br, divider, markTrusted
} from '../ContentComposer/ContentComposer';

// Attach trusted HTML helpers directly to GenericModal and Modal constructors
GenericModal.html = html;
GenericModal.markTrusted = markTrusted;
Modal.html = html;
Modal.markTrusted = markTrusted;

// Global exports for legacy support
if (typeof window !== 'undefined') {
    window.GenericModal = GenericModal;
    window.Modal = Modal;
    window.html = html;
    window.markTrusted = markTrusted;
    window.text = text;
    window.header = header;
    window.ordered = ordered;
    window.unordered = unordered;
    window.bold = bold;
    window.italic = italic;
    window.code = code;
    window.link = link;
    window.br = br;
    window.divider = divider;

    // Backward compatibility aliases
    window.showGenericModal = (options) => GenericModal.create(options).show();
    window.showLoadingModal = (options) => Modal.showLoading(options);
    window.hideLoadingModal = () => Modal.hideLoading();

    // Legacy Shim for Loading Page
    window.ACTSLoadingPageModal = function (timeoutDuration) {
        var duration = timeoutDuration || 1000;
        const $ = window.jQuery;
        if ($) {
            setTimeout(function () {
                $('#ACTSPageLoading').fadeOut('slow', function () {
                    $('#ACTSBody').fadeIn('slow');
                });
            }, duration);
        }
    };

    // Integration
    GenericModal.DataTable = window.DataTableAdapter || null;
    GenericModal.html = html;
}

export { GenericModal, Modal, html, text, header, ordered, unordered, bold, italic, code, link, br, divider };
